import { combineReducers } from "redux";

import method_of_testing from "../features/admin/masters/method_of_testing/Slice";
import customer_type from "../features/admin/masters/customer_type/Slice";
import preffered_communication_mode from "../features/admin/masters/prefferedcommunicationmode/Slice";
import parameter from "../features/admin/masters/parameters/Slice";
import material_tested from "../features/admin/masters/material_tested/Slice";
import test_method from "../features/admin/masters/test_method/Slice";
import component from "../features/admin/masters/component/Slice";
import relevant_training from "../features/admin/masters/relevant_training/Slice";
import designation from "../features/admin/masters/designation/Slice";
import relevanttraining from "../features/admin/masters/relevanttraining/Slice";
import specialization from "../features/admin/masters/specialization/Slice";
import qualification from "../features/admin/masters/qualification/Slice";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import roomtype from "../features/admin/masters/roomtype/Slice";
import service_used from "../features/admin/masters/service_used/Slice";
import test_type from "../features/admin/masters/test_type/Slice";
import type_of_verification from "../features/admin/masters/verification_type/Slice";
import tested_by from "../features/admin/masters/testedby/Slice";
import nature_of_complaint from "../features/admin/masters/nature_of_complaint/Slice";
import department from "../features/admin/masters/department/Slice";
import training_field from "../features/admin/masters/trainingfield/Slice";
import training_type from "../features/admin/masters/trainingtype/Slice";

import payment_method from "../features/admin/masters/payment_method/Slice";

import maintenance_status from "../features/admin/masters/maintenance_status/Slice";

const masters = combineReducers({
  method_of_testing: method_of_testing,
  customer_type: customer_type,
  preffered_communication_mode: preffered_communication_mode,
  parameter: parameter,
  material_tested: material_tested,
  test_method: test_method,
  component: component,
  test_type: test_type,

  relevant_training: relevant_training,
  designation: designation,
  relevanttraining: relevanttraining,
  specialization: specialization,
  qualification: qualification,
  roomtype: roomtype,
  service_used: service_used,

  country: country,
  state: state,
  city: city,
  pincode: pincode,

  test_type: test_type,
  type_of_verification: type_of_verification,
  tested_by: tested_by,
  nature_of_complaint: nature_of_complaint,
  department: department,
  training_type: training_type,
  training_field: training_field,
  payment_method: payment_method,
  maintenance_status: maintenance_status,
});

export default masters;
